import {useState} from "react";

import ReactDOM from "react-dom";

import clockImage from "@images/cards/clock.svg";
import {VideoPopup} from "@popups/VideoPopup";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {SmallDesc} from "@ui/descriptions/SmallDesc";
import {RootIcon} from "@ui/icons/RootIcon";
import {Route, Routes, useNavigate} from "react-router-dom";

import styles from "./styles.module.scss";

export const VideosCardLayout = ({video}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const navigate = useNavigate();

  const handleOpenPopup = (id) => {
    navigate(`video/${id}`);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    navigate(-1);
    setIsPopupOpen(false);
  };

  return (
    <>
      <div
        key={video?.id}
        className={styles.card}
      >
        <div
          className={styles.cardPreview}
          style={
            video?.image
              ? {backgroundImage: `url(${video?.image})`}
              : {background: "var(--greyLight)"}
          }
        >
          <ul className={styles.cardOptions}>
            <li>
              <SmallDesc>
                <span>{video?.category}</span>
              </SmallDesc>
            </li>

            <li>
              <img
                src={clockImage}
                alt={"clock"}
              />
              <SmallDesc>
                <span>{video?.time}</span>
              </SmallDesc>
            </li>
          </ul>

          <div
            onClick={() => handleOpenPopup(video?.id)}
            className={styles.cardPlay}
          >
            <RootIcon id={"play"} />
          </div>
        </div>

        <div className={styles.cardContent}>
          <RootDesc>
            <b dangerouslySetInnerHTML={{__html: video?.title}} />
          </RootDesc>

          <RootDesc>
            <span
              className={"text-[var(--grey)]"}
              dangerouslySetInnerHTML={{__html: video?.description}}
            />
          </RootDesc>
        </div>
      </div>

      <Routes>
        <Route
          path={"video/:id"}
          element={
            <>
              {isPopupOpen &&
                ReactDOM.createPortal(
                  <VideoPopup
                    video={video}
                    onClick={handleClosePopup}
                  />,
                  document.querySelector("body"),
                )}
            </>
          }
        />
      </Routes>
    </>
  );
};
